// extracted by mini-css-extract-plugin
export default {"companyDetails":"CompanyDetails_companyDetails__T5Po8"};